import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/blueprints/recommended';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  try {
    const { workspaceId } = action?.payload || {};
    const headers = getLocalUser();
    if (workspaceId) headers['X-Workspace-Id'] = workspaceId;
    const response = yield call(
      axios.get,
      `${config.API_URL}/models/recommended`,
      { headers },
    );
    yield put(fetchSuccess(
      response?.data?.data?.blueprint || response?.data?.blueprint || null,
    ));
  } catch (error) {
    // Best-effort fetch: no recommendation yet is a normal state and the
    // wizard silently stays manual — don't raise the global error handler.
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
